import { render, staticRenderFns } from "./ing.vue?vue&type=template&id=351e7c15&scoped=true&"
import script from "./ing.vue?vue&type=script&lang=js&"
export * from "./ing.vue?vue&type=script&lang=js&"
import style0 from "./ing.vue?vue&type=style&index=0&id=351e7c15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e7c15",
  null
  
)

export default component.exports